<template>
  <a
    class="c-text-link"
    :tag="tag"
    :class="[customizeColorClass, { 'c-text-link--has_line': hasUnderline }]"
    :target="isLinkTag && blank ? '_blank' : '_self'"
    :rel="isLinkTag && blank ? 'noopener noreferrer' : ''"
    @click="emitClickEvent"
  >
    <slot />
  </a>
</template>

<script lang="ts">
import commons from "@/common/store/modules/commons";
import { Options, Vue } from 'vue-class-component';

import { mapState } from "vuex";
@Options({
  props: {
    hasUnderline: { type: Boolean, required: false, default: false },
    tag: { type: String, default: "a" },
    bold: { type: Boolean, required: false, default: false },
    blank: { type: Boolean, required: false, default: false },
    unuseCustomizeColor: { type: Boolean, required: false, default: false }
  }
})
export default class TextLink extends Vue {
  hasUnderline!: boolean;
  tag!: string;
  bold!: boolean;
  blank!: boolean;
  unuseCustomizeColor!: boolean;

  get customizeColor() {
    return commons.OrgPageSpecific?.page_color;
  }
  get customizeColorClass() {
    return !this.unuseCustomizeColor
      ? `u-text-color--${this.customizeColor}`
      : "";
  }
  get isLinkTag() {
    return this.tag === "a";
  }
  emitClickEvent() {
    this.$emit("click-button");
  }
}
</script>

<style lang="scss" scoped>
.c-text-link {
  &--has_line {
    text-decoration: underline;
  }
}
</style>
